const DialogRootPortalId = "dialog-portal";

function getRootDialogPortal() {
  const dialogPortal = document.getElementById(DialogRootPortalId);

  if (!dialogPortal) {
    throw Error("DIALOG_ROOT_MISSING");
  }

  return dialogPortal;
}

export { DialogRootPortalId, getRootDialogPortal };
